<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/64/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/64/title-1.png" alt="" />
                    <div class="content">
                        凡崇州行政区域内依法注册且工商、税务征管关系在本市的用人单位（不含机关事业单位），从市外、国（境）外引进或自主培育的急需紧缺人才和高端人才。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/55/title-2.png" alt="" />
                    <div class="content">
                        <div class="des">
                            (一) 工作关系在崇州的“蓉城人才绿卡”市级卡持有人。
                        </div>
                        <div class="des">
                            (二)
                            工作关系在崇州，且符合《崇州市急需紧缺人才和高端人才目录》A、B、C类认定标准的人才。
                        </div>
                        <div class="des">
                            (三)
                            工作关系、社保关系均在崇州，且符合《崇州市急需紧缺人才和高端人才目录》D类认定标准的人才。
                        </div>
                        <div class="des">
                            (四)
                            经市人才工作领导小组“一事一议”确定，确需纳入“崇州卡”服务保障范围的其他人才。
                            “崇州人才绿卡”服务对象，依据经济社会发展和人才队伍建设需要适时更新。
                        </div>
                    </div>
                </div>

                <div class="zccl">
                    <img class="top" src="./../assets/imgs/64/title-3.png" alt="" />
                    <div class="content">
                        <div>
                            <span class="hollow-cricle"></span>为“崇州卡”持有人提供政务办理、创新创业、商务服务、生活服务等具有本地特色的服务事项。
                        </div>
                        <div class="des">
                            <div class="title">政务服务</div>
                            1.在市政务服务中心设置人才便捷窗口，提供随到随办、大厅导办等服务。<br />
                            2.在市人才综合服务窗口享受“一窗接件、全程代办”人才政策申报，以及社保、医保、就业、人事代理等导办代办服务。<br />
                            3.提供一年不限次数的免费法律咨询服务。<br />
                            4.在交管部门设置的“绿色通道”优先办理车驾业务。
                        </div>
                        <div class="des">
                            <div class="title">金融服务</div>
                            持卡人（仅限女性人才）申办“巾帼贷”可享受与获得三八红旗手、巾帼创新创业示范基地、以及获得省、市妇联组织授予的其他荣誉称号的同等优惠服务（贷款利率最高不超过6.8%，并由市妇联在最高100万元额度内对贷款同期的LPR利率进行100%利息补贴）。
                        </div>
                        <div class="des">
                            <div class="title">创新创业服务</div>
                            1.协助申报国家、省、成都市各类科技项目，定期推送相关申报信息，协助申请人填写申报资料。<br />
                            2.协助申报国家、省、成都市级重点人才计划，定期推送相关申报信息，实行项目申报“一对一”辅导，指导填写申报资料。<br />
                            3.持卡人享优先入驻天府好粮油“321”产业社区办公场地租赁补贴。前2年按不高于12元/平方米/月的标准予以补贴，后3年按实际租金50%（不高于6元/平方米/月）予以补贴，每年补贴总额不超过实际租金。<br />
                            4.为落地成都人才科创中心的持卡人所在企业免租金6个月，并提供一站式企业活动服务.
                        </div>
                        <div class="des">
                            <div class="title">子女入学入园</div>
                            持卡人子女在本市范围内就读幼儿园的，安排至普惠性幼儿园就读，如需在非普惠性幼儿园就读的，根据实际情况协调安排入学；义务教育阶段，持卡人才属ABCD类人才的，一次性自由选择学校就读，其它持卡人子女根据学位等实际情况，就近协调到公办学校入学；高中阶段（含就读中职学校），同等条件下优先录取。
                        </div>
                        <div class="des">
                            <div class="title">生活服务</div>
                            1.持卡人可凭卡在城区内免费乘坐公交。<br />
                            2.持卡人可凭卡享受市人民医院、妇幼保健院、中医医院专属窗口优先挂号、收费、取药的窗口服务。<br />
                            3.持卡人可凭卡享受崇州图书馆公共图书借阅、数字图书馆使用等服务；优先安排或免费观看崇州市影视文化艺术中心公益文化艺术展演。。<br />
                            4.持卡人可凭卡免费参观崇州市博物馆、罨画池博物馆。<br />
                            5.持卡人属A类、B类、C类人才的，享城区内公共区域停车免费；持卡人属D类人才的，享城区内公共区域停车5折优惠服务。<br />
                            6.持卡人可凭卡携带1-3人免费游览崇州市博物馆、罨画池博物馆、街子古镇味江景区等场所游玩。<br />
                            7.持卡人在市内40家指定餐饮、酒店享受5-9.5折生活优惠服务
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/55/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">提交申请</div>
                                </div>
                                <div class="line-content">
                                    申请人经所在单位同意，向主管部门或所在产业功能区管理机构提交申领表和证明材料原件及复印件。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">初审</div>
                                </div>
                                <div class="line-content">
                                    业务主管部门或功能区管理机构对申领人基本信息和证明材料进行初审
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">核准</div>
                                </div>
                                <div class="line-content">
                                    市人社局会同市级相关部门对初审通过人员资料进行审核，审核不通过则向申请人反馈审核结果，审核通过，则提出发卡建议名单
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line" style="height: 120%"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">审批</div>
                                </div>
                                <div class="line-content">
                                    市人才工作领导小组办公室审批“崇州人才绿卡”发卡名单，征求意见
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">制卡发卡</div>
                                </div>
                                <div class="line-content">
                                    市人才办完成制卡后，由行业主管部门或功能区管理机构领回后发给申请人。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="codes" style="margin-top: 0.8rem">
                    <img class="code" src="../assets/imgs/64/code.png" />
                    <img class="text" src="../assets/imgs/64/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                line-height: 0.44rem;

                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;
                }
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.65rem;
            }
        }
    }
}
</style>
